import { markdownToHtml } from '../../utils/markdownToHtml.js';

function normalizeEmptyHtml(value) {
  if (value == null) return '';
  const normalized = String(value).trim();
  if (normalized === '' || normalized === '<p></p>') return '';
  return normalized;
}

const INPUT_FORMAT_AUTO = 'auto';
const INPUT_FORMAT_HTML = 'html';
const INPUT_FORMAT_MARKDOWN = 'markdown';
const INPUT_FORMAT_TEXT = 'text';

function looksLikeHtml(value) {
  return /<\/?[a-z][\s\S]*>/i.test(value);
}

function looksLikeMarkdown(value) {
  return /(^|\n)\s{0,3}(#{1,6}\s+|[-*+]\s+|\d+\.\s+|>\s+|```)|\*\*.+?\*\*|`.+?`|\[.+?\]\(.+?\)/m.test(
    value
  );
}

function normalizeInputValue(value) {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  return String(value);
}

export function detectInputFormat(value) {
  const normalizedValue = normalizeInputValue(value).trim();
  if (!normalizedValue) return INPUT_FORMAT_TEXT;
  if (looksLikeHtml(normalizedValue)) return INPUT_FORMAT_HTML;
  if (looksLikeMarkdown(normalizedValue)) return INPUT_FORMAT_MARKDOWN;
  return INPUT_FORMAT_TEXT;
}

export function textToHtml(text) {
  if (text == null || text === '') return '';

  const escaped = String(text)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;');

  return escaped
    .split('\n')
    .map((line) => `<p>${line || '<br />'}</p>`)
    .join('');
}

export function normalizeEditorInput(value, inputFormat = INPUT_FORMAT_AUTO) {
  const normalizedValue = normalizeInputValue(value);
  if (!normalizedValue.trim()) return '';

  const resolvedFormat =
    inputFormat === INPUT_FORMAT_AUTO
      ? detectInputFormat(normalizedValue)
      : inputFormat;

  if (resolvedFormat === INPUT_FORMAT_HTML) return normalizedValue;
  if (resolvedFormat === INPUT_FORMAT_MARKDOWN) {
    // Controlled editors often persist `payload.html` after first change.
    // Keep it as-is to avoid re-parsing HTML as markdown and showing escaped tags.
    if (looksLikeHtml(normalizedValue)) return normalizedValue;
    return markdownToHtml(normalizedValue);
  }
  return textToHtml(normalizedValue);
}

export function getContentPayload(editor) {
  return {
    html: editor.getHTML(),
    json: editor.getJSON(),
    text: editor.getText(),
  };
}

export function getSelectionContext(editor) {
  const { from, to, empty } = editor.state.selection;
  const selectedText = editor.state.doc.textBetween(from, to, ' ');

  return {
    from,
    to,
    isCollapsed: empty,
    selectedText,
    fullText: editor.getText(),
    html: editor.getHTML(),
  };
}

export function isExternalValueDifferent(editor, externalValue) {
  const currentHtml = normalizeEmptyHtml(editor.getHTML());
  const incomingHtml = normalizeEmptyHtml(externalValue);
  return currentHtml !== incomingHtml;
}
